const dev = {
  SIGNIFICANT_DIGITS: 3
};

const prod = {
  SIGNIFICANT_DIGITS: 3
};

// Default to dev if not set
const config = process.env.REACT_APP_STAGE === 'prod'
  ? prod
  : dev;

export default {
  SIGNIFICANT_DIGITS: 3,
  BASE_URL: 'https://allosense-tracker-beta.s3.amazonaws.com/devices',
  MAPBOX_STYLE: 'mapbox://styles/mapbox/light-v9',
  //https://docs.mapbox.com/api/maps/#styles
  //'mapbox://styles/mapbox/satellite-v9'
  //'mapbox://styles/mapbox/dark-v9',
  //'mapbox://styles/mapbox/light-v9',
  //'mapbox://styles/roman-allosense/ck8v6zlhm21vl1ir0nk3xwa3q',
  MAPBOX_TOKEN: 'pk.eyJ1Ijoicm9tYW4tYWxsb3NlbnNlIiwiYSI6ImNrMjR2djJwbzI5N2wzY3E4cnN2bWZjenAifQ.WTIiSyGIweL5w1OTEDZrLg',
  POLL_INTERVAL: 2000,
  INIT_ZOOM: 13,
  INIT_PITCH: 45,
  ENABLE_3D: true,
  ...config
};